import {Component, Renderer2} from '@angular/core';
import {NavigationService} from '../../base/navigation/navigation.service';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../base/base.component';

@Component({
  selector: 'app-ru-layout',
  templateUrl: './ru-layout.component.html',
})
export class RuLayoutComponent extends BaseComponent {
  tariffs = [
    {
      title: 'Эко',
      speed: 'до 15',
      measure: 'км/час',
      price: '2',
      currency: '₽\\мин',
    },
    {
      title: 'Драйв',
      speed: 'до 20',
      measure: 'км/час',
      price: '3',
      currency: '₽\\мин',
    },
    {
      title: 'Спорт',
      speed: 'до 25',
      measure: 'км/час',
      price: '5',
      currency: '₽\\мин',
    },
    {
      title: 'Полчаса',
      speed: '',
      measure: '',
      price: '60',
      currency: '₽',
    },
    {
      title: 'Час',
      speed: '',
      measure: '',
      price: '120',
      currency: '₽',
    },
  ];

  constructor(
    public navigationService: NavigationService,
    public renderer: Renderer2,
    protected router: Router,
    public titleService: Title) {
    super(navigationService, router, renderer);
    this.titleService.setTitle('BusyFly - аренда самокатов и велосипедов в твоем городе');
  }
}
